import { makeInitSoul, soulParse, walkSoul } from '../helpers/soulhelper'

export default {
  state: {
    soul: {},
    soulFold: false, // 图表配置是否折叠
    soulSimple: false, // 是否过滤echarts有的属性简化soul，来达到显示的目的
    needShowMore: true, // 是否显示更多
    showMoreLimit: 10, // needShowMore=true时，显示更多的个数限制，超过显示10个，就显示更多
  },
  getters: {
    soul: ({ soul }) => soul,
    soulFold: ({ soulFold }) => soulFold,
    soulSimple: ({ soulSimple }) => soulSimple,
    needShowMore: ({ needShowMore }) => needShowMore,
    showMoreLimit: ({ showMoreLimit }) => showMoreLimit,
  },
  actions: {
    restoreSoul ({ commit, state }, echartsOptions) {
      if (typeof echartsOptions === 'string') echartsOptions = JSON.parse(echartsOptions)
      const soul = echartsOptions ? soulParse(echartsOptions) : makeInitSoul()

      // 如果是简化，设置隐藏属性，渲染的时候不显示这些属性
      walkSoul(soul, (soulItem) => {
        if (state.soulSimple) {
          if (!soulItem.existInEchartsOptions) {
            soulItem.hideInEditor = true
            // console.log(soulItem.name, 'hideInEditor')
          }
        }
        // 对isMore进行统一处理，有些可能没有isMore（比如数组中的项）
        if (!soulItem.hasOwnProperty('isMore')) {
          soulItem.isMore = false
        }
        // end
        
        // 冻结无用的数据，提高性能
        Object.freeze(soulItem.name);
        Object.freeze(soulItem.nickname);
        Object.freeze(soulItem.desc);
        Object.freeze(soulItem.defaultValue);
        Object.freeze(soulItem.type);
        Object.freeze(soulItem.isExpandForce)
        if (soulItem.type === 'array' || soulItem.type === 'typeArray' || soulItem.type === 'richMap') {
          Object.freeze(soulItem.props);
        }
        // end
      })

      // https://vuedose.tips/tips/improve-performance-on-large-lists-in-vue-js/
      // Object.freeze(soul); freeze那些没有使用到的东西
      commit('setSoul', soul)
    },
    foldSoul ({ commit, state }, payload) {
      walkSoul(state.soul, (soulItem) => {
        if (!soulItem.isExpandForce) {
          soulItem.isExpand = payload
        } else {
          soulItem.isExpand = true
        }
      })
      commit('setSoulFold', payload)
    },
    simpleSoul ({ commit, getters, dispatch }, payload) {
      commit('setSoulSimple', payload)
      dispatch('restoreSoul', getters.jsonCode)
    },
    saveSoul () {
    }
  },
  mutations: {
    setSoul (state, val) {
      state.soul = val
    },
    setSoulFold (state, val) {
      state.soulFold = val
    },
    setSoulSimple (state, val) {
      state.soulSimple = val
    },
    setNeedShowMore (state, val) {
      state.needShowMore = val
    },
  }
}
